import { AppIdentifier } from "../../types";
import { appIdentifierToActionPrefixMap } from "../../types";
import {
  ACTION_SET_JWT,
  ACTION_SET_MODAL_STATE,
  ACTION_APP_LOADED
} from "./constants";

export interface ICryptoSellState {
  jwt: string;
  isAppLoaded: boolean;
  isAppActive: boolean;
}

export interface ICryptoSellAction {
  type: string;
  jwt?: string;
  isAppActive?: boolean;
  isAppLoaded?: boolean;
}

const INITIAL_STATE: ICryptoSellState = {
  jwt: "",
  isAppActive: false,
  isAppLoaded: false
}

const applySetIsAppActive = (state: ICryptoSellState, action: ICryptoSellAction) : ICryptoSellState => {
  return {
      ...state,
      isAppActive: !!action.isAppActive,
  }
}

const applySetSendJWTToApp = (state: ICryptoSellState, action: ICryptoSellAction) : ICryptoSellState => {
  return {
      ...state,
      isAppLoaded: !!action.isAppLoaded,
  }
}

const applySetJWT = (state: ICryptoSellState, action: ICryptoSellAction) : ICryptoSellState => {
  return {
      ...state,
      jwt: action.jwt as string,
  }
}

const reducerMap: { [actionType: string]: (state: ICryptoSellState, action: ICryptoSellAction) => ICryptoSellState } = {
  // Crypto sell reducer
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.CRYPTO_SELL)}${ACTION_SET_JWT}`]: applySetJWT,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.CRYPTO_SELL)}${ACTION_SET_MODAL_STATE}`]: applySetIsAppActive,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.CRYPTO_SELL)}${ACTION_APP_LOADED}`]: applySetSendJWTToApp,
};

const cryptoSellReducer = (state = INITIAL_STATE, action: ICryptoSellAction) => {
  if (!!action.type && !!reducerMap[action.type]) {
      return reducerMap[action.type](state, action);
  } else {
      return state;
  }
}

export default cryptoSellReducer;
